
import { defineComponent, ref } from "vue";

import Child from "./components/Child.vue";
export default defineComponent({
    name: "Parent",
    components: {
        Child,
    },
    beforeCreate() {
        console.log('Parent--beforeCreate执行了');
    },
    // 页面渲染完毕
    mounted() {
        console.log('Parent--mounted', this);
    },
    data() {
        return {
            // msg: '我是data里的msg'
            name: 'name',
        }
    },
    methods: {
        b() {
            console.log('Parent--bbb');
        }
    },
    setup() {
        console.log("Parent--setup执行了", this);
        const msg = ref("ref");
        function a() {
            console.log('Parent--123');
        }
        return {
            msg,
            a,
        };
    },
});
